import GeofenceSettings from "./geofenceSettingsContainer";
export default GeofenceSettings;